<template>
  <div v-if="loading">
    <spinner />
  </div>
  <sport-store-container
    v-else
    :organization="organization"
    :schema="schema"
    :title="$t('annualTicket')"
    :cover-url="organization.imageUrls.subscriptionCoverUrl"
  />
</template>

<script>
import SportStoreContainer from '@/components/accreditations/organization-store/SportStoreContainer.vue'
import { GET_ORGANIZATION_BY_SLUG } from '@/graphql/organization.graphql'
import { createAttendeeSchema } from '@/utils'

export default {
  name: 'sport-subscriptions-store-container',
  components: {
    SportStoreContainer,
  },
  props: {
    organizationSlug: String,
  },
  data() {
    return {
      organization: null,
      schema: {},
      loading: true,
    }
  },
  apollo: {
    getOrganizationBySlug: {
      query: GET_ORGANIZATION_BY_SLUG,
      variables() {
        return { organizationSlug: this.organizationSlug }
      },
      manual: true,
      result({ data, loading }) {
        if (!loading && data) {
          this.organization = data.getOrganizationBySlug
          if (this.organization.attendeeFields.subscriptionFields) {
            this.schema = createAttendeeSchema(this.organization.attendeeFields.subscriptionFields)
          }

          this.loading = false
        }
      },
    },
  },
}
</script>

<style scoped></style>
